import {motion} from "framer-motion";

import Button from "./ui/Button";

interface FailedPopupProps {
  onContinue: () => void;
  onRetry: () => void;
}

export default function FailedPopup({onContinue, onRetry}: FailedPopupProps) {

  return (
    <motion.div
      transition={{duration: .3, ease: "easeInOut"}}
      initial={{opacity: 0}}
      animate={{opacity: 1}}
      exit={{opacity: 0}}>
      <div className={'focusing-failed'}>

        <div className="__blinked">You have blinked!</div>


        <div className="__buttons">
          <Button type={"secondary"} onClick={onContinue} sub={"continue"}>No, I've not!</Button>
          <Button type={"primary"} onClick={onRetry} sub={"go back and prep for next try"}>Retry</Button>
        </div>
      </div>
    </motion.div>
  )
}